/**
 * Pre-compiled en messages for Drawer
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { closeTrigger: `Close drawer` };
